export default __webpack_public_path__ + "static/media/boxing-glove.679ef4dc.svg";